import { Listener } from './Listener';
import { TrackingHandler } from '../TrackingHandler';
import { initPhoneTracking } from '../phonetracking';
export class PhoneTrackingListener extends Listener {
    phoneTrackingInitialized = false;
    pageReady() {
        if (this.phoneTrackingInitialized) {
            return;
        }
        const trackingHandler = TrackingHandler.getInstance();
        if (trackingHandler.consent.essential) {
            initPhoneTracking(TrackingHandler.getInstance().visitorId);
            this.phoneTrackingInitialized = true;
        }
    }
    setConsent(essential, functional, marketing) {
        if (this.phoneTrackingInitialized) {
            return;
        }
        if (essential) {
            initPhoneTracking(TrackingHandler.getInstance().visitorId);
            this.phoneTrackingInitialized = true;
        }
    }
}
